import { render } from "./SIgnUp.vue?vue&type=template&id=53064e20"
import script from "./SIgnUp.vue?vue&type=script&lang=js"
export * from "./SIgnUp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__